/**
 * Customer "submit a new ticket" mutation.
 *
 * The server enforces the source / priority / type restrictions from
 * SPEC §8 NewTicketPage; we shape the wire body to match
 * ``TicketCreateRequest`` and let the API downgrade Urgent if it
 * somehow sneaks through (the UI hides it).
 */
import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from "@tanstack/react-query";

import api from "@/lib/api";
import type { TicketCreateRequest, TicketResponse } from "@/types/api";

export function useCreateTicket(): UseMutationResult<
  TicketResponse,
  Error,
  TicketCreateRequest
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: TicketCreateRequest) => {
      const response = await api.post<TicketResponse>("/tickets", body);
      return response.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["tickets", "list"] });
    },
  });
}
